import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function ThemedShowCaseSection(props) {
  const config = useThemeConfig();
  const ThemedShowCaseSection = config.components.ShowCaseSection;

  return <ThemedShowCaseSection {...props} />;
}
